var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import React from "react";
import { Anchor } from "grommet";
import styled from "styled-components";
export var CustomTbody = styled.tbody(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  font-family: Gotham Pro;\n  color: #313131;\n  font-size: 16px;\n  white-space: nowrap;\n  overflow: auto;\n\n  & table {\n    width: 100%;\n    border-collapse: collapse;\n    text-align: center;\n  }\n\n  & th {\n    padding: 10px;\n    text-align: left;\n    border-left: 2px solid #dadde0;\n    background-color: #e8eaec;\n    text-align: center;\n  }\n\n  & th:first-child {\n    max-width: 56px;\n    color: #777777;\n    font-weight: 400;\n    text-align: center;\n    border-left: none;\n  }\n\n  & tr {\n    border-top: 2px solid #e8eaec;\n  }\n\n  & tr:first-child {\n    border-top: none;\n  }\n\n  & td {\n    padding: 10px;\n    background-color: #f8f8f8;\n    border-left: 2px solid #e8eaec;\n  }\n\n  & td:first-child {\n    max-width: 56px;\n    color: #777777;\n    text-align: center;\n    border-left: none;\n  }\n\n  & td:nth-child(4) {\n    min-width: 180px;\n  }\n\n  & tr:first-child th:first-child {\n    border-top-left-radius: 24px;\n  }\n\n  & tr:first-child th:last-child {\n    border-top-right-radius: 24px;\n  }\n\n  & tr:last-child td:first-child {\n    border-bottom-left-radius: 24px;\n  }\n\n  & tr:last-child td:last-child {\n    border-bottom-right-radius: 24px;\n  }\n",
    ]))
);
export var CustomTable = function CustomTable(_ref) {
  var headList = _ref.headList,
    content = _ref.content;
  return /*#__PURE__*/ React.createElement(
    CustomTbody,
    null,
    /*#__PURE__*/ React.createElement(
      "table",
      null,
      /*#__PURE__*/ React.createElement(
        "tr",
        null,
        headList.map(function (item) {
          return /*#__PURE__*/ React.createElement(
            "th",
            {
              key: item.name,
            },
            item.label
          );
        })
      ),
      content.map(function (item) {
        return /*#__PURE__*/ React.createElement(
          "tr",
          {
            key: item.id,
          },
          /*#__PURE__*/ React.createElement("td", null, item.id),
          /*#__PURE__*/ React.createElement("td", null, item.name),
          /*#__PURE__*/ React.createElement(
            "td",
            null,
            /*#__PURE__*/ React.createElement(
              Anchor,
              {
                href: "tel:" + item.phone,
              },
              item.phone
            )
          ),
          /*#__PURE__*/ React.createElement(
            "td",
            null,
            /*#__PURE__*/ React.createElement(
              Anchor,
              {
                href: "mailto:" + item.email,
              },
              item.email
            )
          ),
          /*#__PURE__*/ React.createElement(
            "td",
            null,
            /*#__PURE__*/ React.createElement(
              Anchor,
              {
                href: item.link,
              },
              item.link
            )
          )
        );
      })
    )
  );
};
